<template>
<div>
    <div id="viewer" ref="viewer" style="position: absolute; left: 0; right: 0" data-bind="dxReportViewer: $data">
    </div>
    <DxPopup
        :visible="showMailTo"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        title="Send by Email"
        @hidden="onHidden"
        @shown="emitOnShown"
        :resize-enabled="true"
        :enable-body-scroll="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="463px"
        min-height="463px"
        width="50vw"
        :wrapper-attr="popupAttributes"
      >

      <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdEdit 
                v-bind:Label="'To'"
                v-bind:Name="'to'"
                v-bind:TypeProp="'text'"                      
                v-model="modelTo"
                v-bind:isRequired="true"
                v-bind:isValid="isValidTo"
                ref="mailTo"
                v-bind:Id="'mailTo'"
                v-bind:Placeholder= "placeHolderEmail"               
            />   
          </b-col> 
      </b-row>
      <b-row>
          <b-col md="12" lg="12" sm="12">
            <MdEdit 
                v-bind:Label="'CC'"
                v-bind:TypeProp="'text'"             
                v-bind:Name="'cc'"
                v-model="modelCC"
                v-bind:Placeholder= "placeHolderEmail" >                                 
            </MdEdit>
        </b-col>   
      </b-row>
      <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdEdit 
                v-bind:Label="'Subject'"
                v-bind:Name="'subject'"
                v-bind:TypeProp="'text'"                      
                v-model="modelSubject"/>   
          </b-col> 
      </b-row>
      <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdMemo
                v-bind:Name="'body'"
                v-bind:Rows="'5'"
                v-bind:MaxRows="'250'"           
                v-model="modelBody"
            />   
          </b-col> 
      </b-row>
     
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="sendemailButtonOptions"
      />
      </DxPopup>

      <Loading v-bind:IsLoading="this.Load" /> 
     
</div>
</template>

<script>
import ko from "knockout";
import { ActionId, PreviewElements } from 'devexpress-reporting/dx-webdocumentviewer'
import 'devexpress-reporting/dx-webdocumentviewer'
import ApiService from '@/services/api.service'
import StorageService from '@/services/storage.service'
import { ajaxSetup } from "@devexpress/analytics-core/analytics-utils"
import { on } from 'devextreme/events';
import { DxPopup, DxToolbarItem  } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading';
import notify from 'devextreme/ui/notify';
import $ from "jquery";

export default {
name: "ReportViewer",
mixins: [ShowMessage],
components: { DxPopup, DxToolbarItem, Loading  },
props: {
    ReportName: String,
    ReportTitle: String,
    IsAnAPIReport: Boolean,
    IsANotesReport: Boolean,
    HideSearch: Boolean
},
data() {
    return {
        previewModel: ko.observable(),
        paramsStr: '',
        ModalId: 'reportviewer',
        TitleWindow: this.ReportTitle,
        showMailTo: false,
        popupAttributes: {
            id: 'modalMailTo'
        },
        modelCC: '',
        modelTo: '',
        modelSubject: 'Report by email...',
        modelBody: '',
        documentViewer: null,
        documentPreview: null,
        isValidTo: true,
        Load: false,
        placeHolderEmail: "user1@domain.com, user2@domain.com" 
    }
},

computed: {
    sendemailButtonOptions() {
      return {
        stylingMode: 'contained',
        text: 'Send',
        type: 'primary',
        onClick: () => {
            this.sendMail()
        },
      };
    },

    cancelButtonOptions() {
        return {
        text: 'Cancel',
        type: 'primary',
        onClick: () => {
            this.onHidden()
        },
      };
    }
},

methods: {

    emitOnShown(){
       this.$refs.mailTo.setFocus()  
    },

    validate_entries() {
         this.isValidTo = this.modelTo.length > 5  ? true : false
         return this.isValidTo
      },

    sendMail() {
        if (this.validate_entries()) {
            this.Load = true
            this.onHidden()
            let options = { To: this.modelTo, CC: this.modelCC, Subject: this.modelSubject, Body: this.modelBody }  
            this.documentPreview.PerformCustomDocumentOperation(JSON.stringify(options))
            .done((arg) =>  {
                this.Load = false
                if (arg.succeeded)
                    notify('Document ' + arg.documentId + " : " + arg.message, "success", 10000);
                else
                    notify('Document ' + arg.documentId + " : " + arg.message, "error", 10000);
            });
        }      
    },

    onHidden() {
        this.showMailTo = false
    },

    async buildDocument(params) {
        this.buildParameters(params)
        await this.previewModel().OpenReport(`${this.ReportName}${this.paramsStr}`);
        this.previewModel().reportPreview.zoom(1)        
    },

    buildParameters(params) {
        let ixd = 0
        params.forEach(param => {
            if (ixd === 0) {
                this.paramsStr = `?${param.paramName}=${param.paramValue}` 
            }
            else 
            {
                this.paramsStr = `${this.paramsStr}&${param.paramName}=${param.paramValue}`
            }
            ixd++
        });
        if (this.IsAnAPIReport) {
            if (params != null || params != undefined) {
                this.paramsStr = `${this.paramsStr}&IsAnAPIReport=true`
            }
            else {
                this.paramsStr = `?IsAnAPIReport=true`
            }
        }
        if (this.IsANotesReport) {
            if (params != null || params != undefined) {
                this.paramsStr = `${this.paramsStr}&IsANotesReport=true`
            }
            else {
                this.paramsStr = `?IsANotesReport=true`
            }
        }
    },
},

created: function() {
    this.$parent.$on('buildDocument');
},

mounted() {    
    ajaxSetup.ajaxSettings = { headers: { 'Authorization': `Bearer ${StorageService.getOnlyToken()}` } };
    var root = this
    var viewerOptions = {
        requestOptions: {
            host: ApiService.APIURL,
            invokeAction: "/DocumentViewer/Invoke"
        },
        exportSettings: {
            showPrintNotificationDialog: false
        },
        isMobile: window.innerWidth <= 780 ? true: false,
        callbacks: { 
            DocumentReady: function(s) {
               s.GetReportPreview().zoom(1);
               const parent = document.getElementById("viewer");
               on(parent, "dxmousewheel", null, function (evt) {
                    evt.stopPropagation();
               });
            },
            BeforeRender(s, e) {
                e.reportPreview.showMultipagePreview(true);
            },
            CustomizeMenuActions: function(s, e) {
                if (root.HideSearch) {
                    let actionSearch = e.GetById(ActionId.Search);
                    if (actionSearch) actionSearch.visible = false;
                }

                let actionPrintPage = e.GetById(ActionId.PrintPage);
                    if (actionPrintPage) actionPrintPage.visible = false;
                
                let actionMultipageToggle = e.GetById(
                    ActionId.MultipageToggle
                );
                if (actionMultipageToggle) actionMultipageToggle.visible = false;

                e.Actions.push({
                    text: "Send by Email",
                    imageClassName: "mailto",
                    visible: true,
                    disabled: false,
                    hasSeparator: false,
                    hotKey: { ctrlKey: true, keyCode: "Z".charCodeAt(0) },
                    clickAction: function () {
                        root.showMailTo = true
                        root.documentPreview = s
                    } 
                });
            },
            CustomizeParameterEditors: function(s,e) {
                if (e.parameter.type === 'System.DateTime') {
                    e.info.editor = $.extend({}, e.info.editor);
                    e.info.editor.extendedOptions = $.extend(e.info.editor.extendedOptions || {}, { type: 'date' });
                }
            },
            CustomizeElements: function(s,e) {
                if (root.HideSearch) {
                    var panelPart = e.GetById(PreviewElements.RightPanel);
                    var searchPnlIndex = 2;
                    panelPart.model.tabPanel.tabs.splice(searchPnlIndex, 1);
                }
            },
            ParametersSubmitted: function (s,e) {
                const formattedParams = e.Parameters
                                            .map(param => ({
                                                paramName: param.Key,
                                                paramValue: param.Value
                                            }));
                root.$emit("parameters-submitted", formattedParams);
            }
        },
        viewerModel: this.previewModel,
    };
    ko.applyBindings(viewerOptions, this.$refs.viewer);
},

beforeDestroy() {
    ko.cleanNode(this.$refs.viewer);
}
};
</script>
<style>
    .dxrd-preview.dxrd-designer-wrapper .dxrd-preview-wrapper .dxrd-report-preview-brick-selected {
        visibility: hidden;
    }

    .mailto {
        background-image: url("data:image/svg+xml;base64,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");
        background-repeat: no-repeat;
    }

    .dx-button.dx-button-primary {
        background-color: #0F9CD2 !important;
        font-size: 0.875rem;
        line-height: 1;
        font-weight: 500;
    }

    .dx-button.dx-button-primary:hover {
        color: #fff;
        background-color: #026EB5 !important;
    }
</style>

